import { userAtom } from "@framework/config/atoms";
import { useLocation } from "@remix-run/react";

// Keep it simple for now, we will implement it later.
export type FeatureFlag =
  | "leaderboard"
  | "notifications"
  | "darkMode"
  | "telegram"
  | "ramadan"
  | "eidFetr"
  | "eidAdha";

// Partial — a flag intentionally left out of the map is treated as
// "disabled for everyone" by the lookup below. Keeps the seasonal
// flags toggleable by un/commenting their entry without forcing the
// type to claim full coverage.
const FEATURE_FLAGS: Partial<Record<FeatureFlag, boolean>> = {
  darkMode: true,
  telegram: true,
  leaderboard: true,
  notifications: true,
  // ramadan: false,
  // eidFetr: false,
  // eidAdha: false, // Eid Al Adha is over — disabled for everyone.
};

export function useFeatureFlag(flag: FeatureFlag) {
  const user = userAtom.useValue();

  if (FEATURE_FLAGS[flag]) return true;
  if (FEATURE_FLAGS[flag] === undefined) return false;

  return user.email === "hassanzohdy@gmail.com";
}
